mutation commenceKlarnaOrderMutation($params: CommenceKlarnaOrderParams!) {
    commenceKlarnaOrder(params: $params)
  }